import { handleRequestGet,handleRequestPost } from '../axios';
import { parseResult, queryParamStr, queryParamStrArr } from './GeneralFunc';



// export const getTeachAnalyzer = async (keywords = null,mode=null) => {
//     let url = '/tool/reward-point';

//     let result = await handleRequestGet(url, {});
//     return result;
// };


export const getTeachAnalyzer = async () => {
    let url = '/tool/chart-genie';
    let result = await handleRequestPost(url, {  });
    return result;
};